@use "ui/styles/colors";
@use "ui/styles/effects";
@use "ui/styles/fonts";
@use "ui/styles/sizes";

.wrapper {
  padding: sizes.$s4;
  display: flex;
  align-items: center;
  border-radius: effects.$borderRadiusS;
  font-size: fonts.$mid;
  font-weight: fonts.$medium;
  color: colors.$white;

  a {
    color: colors.$white;
    text-decoration: underline;

    &:hover {
      opacity: 80%;
    }
  }

  :global {
    .interior {
      width: 100%;
      position: relative;
      display: flex;
      align-items: center;
      margin-right: sizes.$s4;
    }

    .icon-container,
    .close-container {
      margin: 3px sizes.$s5 0 sizes.$s5;
    }

    .close-container {
      margin-left: auto;

      &:hover {
        cursor: pointer;
      }
    }
  }

  &.sticky {
    position: absolute;
    top: 0;
    width: 100%;
    border-radius: 0;
    z-index: 1000;
    pointer-events: none;
    /* So that e2e tests can click through the element */
  }

  &.centered {
    :global {
      .interior {
        justify-content: center;
      }

      .close-container {
        position: absolute;
        right: 0;
      }
    }
  }

  &.default {
    color: colors.$gray70;
    background-color: colors.$gray20;
    font-weight: fonts.$book;
    padding: 0.75em;
  }

  &.variant-inverted {
    background-color: colors.$gray20;
    color: colors.$gray70;

    a {
      color: colors.$gray70;
    }
  }

  &.success:not(.variant-inverted) {
    background-color: colors.$green;
  }

  &.info:not(.variant-inverted) {
    background-color: colors.$gray50;
  }

  &.warning:not(.variant-inverted) {
    background-color: colors.$yellowLight;
    color: colors.$gray80;

    a {
      color: colors.$gray80;
    }
  }

  &.error:not(.variant-inverted) {
    background-color: colors.$red;
  }

  /* Banner variant uses same layout as standard, only colors differ */
  &.variant-banner {
    &.warning {
      background-color: colors.$yellowLightest;
      color: colors.$yellowDark;

      a {
        color: colors.$yellowDark;
      }
    }

    &.info {
      background-color: colors.$blueLightest;
      color: colors.$blueDark;

      a {
        color: colors.$blueDark;
      }
    }

    &.error {
      background-color: colors.$redLightest;
      color: colors.$redDark;

      a {
        color: colors.$redDark;
      }
    }
  }
}

.marginBottom {
  margin-bottom: sizes.$s6;
}
